import axios from 'axios'

export default {
  // 使用授權碼取得access token
  getAccessToken(code, redirect_uri) {
    // console.log('getAccessToken:'+code)
    return axios.get('https://apitest.issbg.site/issbg/getAccessToken', {
        params: {
            code: code,
            redirect_uri: redirect_uri,
            client_id: 'Elearning',
          }
    }).then(function(response) {
        // console.log('icivic token:'+response.data.token);
    	return response.data.token;
    }).catch(function (error) {
    	console.error('Failed to get access token:', error);
        throw error
  	});
  }
}



// WEBPACK FOOTER //
// ./src/api/oauth.js